var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageDocument = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 29,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7785AD",
  fillRule: "evenodd",
  d: "M3.905.566h20.25c.895 0 1.753.369 2.386 1.025.633.657.988 1.547.988 2.475v21c0 .928-.355 1.819-.988 2.475a3.315 3.315 0 0 1-2.387 1.025H3.904a3.315 3.315 0 0 1-2.386-1.025 3.567 3.567 0 0 1-.988-2.475v-21c0-.928.355-1.818.988-2.475A3.315 3.315 0 0 1 3.905.566Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.749 24.015h18.55l.004-.074c.003-.055.007-.105.007-.155v-1.012c.001-2.04.003-2.078-.01-4.117 0-.157-.104-.349-.217-.466-1.528-1.585-3.066-3.16-4.602-4.735-.669-.686-1.273-.686-1.939-.002l-1.065 1.093c-1.548 1.588-3.097 3.177-4.64 4.77-.09.093-.126.241-.185.362L9.8 18.81c-.65-.661-1.256-1.28-1.866-1.895-.537-.54-1.196-.538-1.732.003l-.129.13c-.378.382-.758.765-1.115 1.167a.846.846 0 0 0-.2.51c-.01 1.871-.01 1.742-.01 3.614v1.676Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9.885,
  cy: 9.849,
  r: 3.092,
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-document.a0e6f9464bd542d44db82214843ff46a.svg";